import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { IdentityEvent } from '../../../common/events/identity'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class OTPEmailForm {
    private static DOM = {
        form: 'sendOTPForm'
    }
    private otpSignInForm: HTMLFormElement

    /**
     * Listens for the form validated event in the send OTP email form
     */
    public init() {
        logger('debug', 'Initializing send OTP email form')
        this.otpSignInForm = document.querySelector(`[data-id-form=${OTPEmailForm.DOM.form}]`)

        if (this.otpSignInForm) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === OTPEmailForm.DOM.form) {
                    await this.submitForm()
                }
            })
        }
        logger('debug', 'Send OTP email form initialized')
    }

    /**
     * Calls send OTP token API
     */
    public async submitForm() {
        const formData = IdentityFormUtils.getFields()
        const email = formData.emailAddress

        try {
            // call send OTP token API
            await IdentityFormAPI.sendOTPToken({email})

            // send form submission event
            LoginService.sendFormSubmissionEvent('send-otp')

            // store email and redirect to verify OTP page
            if (sessionStorage) {
                sessionStorage.setItem(Store.OTP_EMAIL, email)
            }

            location.replace('/verify-otp/')
        } catch (err) {
            logger('error', 'Unable to send email continaing OTP', err)
        }
    }
}
